import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const Input = styled('input')(({ theme }) => ({
  width: '100%',
  height: '42px',
  padding: '8.5px 14px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkBorderColor : TURN_STYLES.borderColor}`,
  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : TURN_STYLES.surfaceColor,
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,

  '&:hover, &:focus': {
    borderColor: TURN_STYLES.primaryAccentColor,
    outline: 'none',
    boxShadow: 'none',
  },

  '&::placeholder': {
    opacity: 0.7,
    color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
  },
}));
